function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
//
//
//
//
//
//
//
//

import formCreateDesigner from './components/form-create-designer/src/index';
export default {
  props: {
    tabName: {
      type: String,
      default: ''
    },
    conf: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      formData: {}
    };
  },
  components: {
    formCreateDesigner: formCreateDesigner
  },
  mounted: function mounted() {
    if (_typeof(this.conf) === 'object' && this.conf !== null) {
      this.$refs.designer.setRule(this.conf.props);
    }
  },
  methods: {
    /**
     * 供父组件使用 获取表单JSON
     */
    getData: function getData() {
      var _this = this;
      return new Promise(function (resolve, reject) {
        var FcDesignerRule = _this.$refs.designer.getJson();
        if (JSON.parse(FcDesignerRule).length === 0) {
          reject({
            msg: '您的行容器中没有组件,请添加组件',
            target: _this.tabName
          });
          return;
        }
        resolve({
          formData: {
            form: {},
            props: JSON.parse(FcDesignerRule)
          }
        });
      });
    }
  }
};